var $17a3672f010e4055$exports = {};
$17a3672f010e4055$exports = {
  "alert": "Upozorenje",
  "dismiss": "Odbaci"
};
export { $17a3672f010e4055$exports as default };